import { FgBlockType } from '../../block-type.js';
import { fgSmoothStep } from '../../fg-math.js';
import { setDataValue, getDataValue } from '../../runtime.js';
import { sockOut, sockIn } from '../../sockets.js';
import { FgType } from '../../types.js';

const smoothStepDef = {
  type: FgBlockType.SmoothStep,
  build: () => ({
    dataIn: [sockIn("a", FgType.Any), sockIn("b", FgType.Any), sockIn("c", FgType.Any)],
    dataOut: [sockOut("value", FgType.Any)]
  }),
  updateOutputs(block, ctx, env) {
    setDataValue(ctx, block, "value", fgSmoothStep(getDataValue(ctx, env, block, "a"), getDataValue(ctx, env, block, "b"), getDataValue(ctx, env, block, "c")));
  }
};

export { smoothStepDef };
//# sourceMappingURL=smooth-step.js.map
